import React, { useState, useEffect} from 'react'
import cvIcon from '../../Assets/icons/cv-icon.png'
import { useAuth} from '../../Context/AuthContext'
import axios from 'axios'
import { toast } from 'react-toastify'
import congrats from '../../Assets/icons/congrats.png'
//Firebase
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from '../../Firebase';

export default function JobsApply({setOpenApply, job, checkIfApplied}) {

  const [step, setStep] = useState(1)
  const [saving, setSaving] = useState(false)

  let { currentUser} = useAuth()

  const [name, setName] = useState(currentUser.displayName)
  const [email, setEmail] = useState(currentUser.email)
  const [fileName, setFileName] = useState("Click to upload cv")
  const [cv, setCv] = useState("")
  const [experience, setExperience] = useState("")
  const [link, setLink] = useState("")
  const [coverLetter, setCoverLetter] = useState("")

  const handleSubmit = () => {
    let payload = {
      jobId: job._id,
      jobTitle: job.title,
      businessId: job.businessId,
      businessName: job.businessName,
      applicantId: currentUser.uid,
      name, 
      email,
      experience,
      link,
      cv,
      coverLetter,
      status: "Pending",
      stage: "Received"
     
    }

    if( !name || !email || !coverLetter) {
      toast.error("Please add all necessary fields")
    } else {
      setSaving(true)
      axios.post(`${process.env.REACT_APP_API_URL}/jobs/apply-for-job`, payload)
      .then(() => {
        setStep(2)
        setSaving(false)
        checkIfApplied()
      })
      .catch((e) => {
        console.log(e)
        setSaving(false)
      })
    }
    
  }
  const fileRef = ref(storage, `freelancer/cvs/${currentUser.uid}`);

  const uploadCV = (file) => {
    if(file?.size > 2097152){
        toast.error("File must be less than 2mb")
      } else if( !file){
        return
      } else {
        setFileName("Uploading...")
        uploadBytes(fileRef, file).then((snapshot) => {
          getDownloadURL(fileRef)
          .then((url) => {
            setFileName(file.name)
            setCv(url)
          })
          .catch((error) => {
              console.log(error)
          });
        });
      }
  }

  return (
    <div id='create-contest'>
        <div id='create-contest-container' style={{paddingTop: '1rem', overflow:'scroll'}}>
            <button onClick={() => setOpenApply(false)} id='close-contest-btn'>x</button>

            {step === 1 &&
            <div style={{padding: '0 1rem'}}>
                <p className='advidity-header' style={{fontSize: 28, marginBottom: 20}}>Apply</p>

                <input className='apply-input' type='text' placeholder='Enter Full Name' value={name} onChange={(e) => setName(e.target.value)}/>

                <input className='apply-input' type='email' placeholder='Enter Email'  value={email} onChange={(e) => setEmail(e.target.value)}/>

                <input className='apply-input' type='number' placeholder='Years of Experience'  value={experience} onChange={(e) => setExperience(e.target.value)}/>

                <input className='apply-input' type='text' placeholder='Link to Webste or Portfolio'  value={link} onChange={(e) => setLink(e.target.value)}/>

                <p className='advidity-header' style={{fontSize: 20, margin: '30px 0 10px 0'}}>Upload CV</p>

                <input type="file"  name="pic1" id="pic1" style={{display:'none'}} onChange={(e)=>uploadCV(e.target.files[0])}/>
                <label htmlFor="pic1">
                <div className='apply-input' style={{display:'flex', justifyContent:'center', alignItems:'center', padding: '3rem 1rem'}}>
                        <img style={{height: 50, width: 50, marginRight: 20}} src={cvIcon} alt='CV icon'/>
                        <p className='advidity-subheader'>{fileName}</p>
                    </div>
                </label>

                <textarea className='apply-input' style={{resize: 'none', height: 200, padding: 10}} placeholder='Why should we hire you?' value={coverLetter} onChange={(e) => setCoverLetter(e.target.value)}/>

                <button className='primary-btn'  onClick={handleSubmit} disabled={saving}>{saving ? "Applying..." : "Submit Application"}</button>

              </div>
            } 

            {step === 2 &&
            <div>

                <div style={{backgroundColor:'#ebebeb', margin: '75px 2rem', borderRadius: 8, textAlign:'center', padding: 10}}>
                    <img  src={congrats} alt='Congratulations image'/>
                </div>
                <p className='advidity-header' style={{fontSize: 28, margin: '2rem'}}>Congratulations, you have successfully submitted your application for this job.</p>

                <button className='primary-btn' style={{margin: '2rem', color: 'white'}} onClick={() => { setOpenApply(false)}}>Close</button>

            </div>
            }

        
          
        </div>
    </div>
  )
}
